import styled, { css } from 'styled-components'

const Container = styled.aside`
  outline: none;
  background-color: ${props => props.theme.color.monochrome.lighter};
  position: fixed;
  z-index: 75;
  top: -100%;
  left: 0;
  right: 0;
  width: 100%;
  transition: top 0.5s ease-in-out;

  ${props =>
    css`
      border-top: ${props.PDP_V2_FLAG ? `1px solid ${props.theme.color.monochrome.light}` : 'none'};
      border-bottom: ${!props.PDP_V2_FLAG ? `1px solid ${props.theme.color.monochrome.light}` : 'none'};
      top: ${props.inView ? (props.PDP_V2_FLAG ? 'auto' : '-100%') : props.PDP_V2_FLAG ? 'auto' : '0'};
      bottom: ${props.inView ? (props.PDP_V2_FLAG ? '100%' : 'auto') : props.PDP_V2_FLAG ? '0' : 'auto'};

      @media (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        top: ${props.inView && props.PDP_V2_FLAG ? '-100%' : '0'};
        bottom: auto;
        border-top: none;
        border-bottom: 1px solid ${props.theme.color.monochrome.light};
      }
    `}
`

export { Container }
